<template>
    <div>
        <h4 class="mb-1">
            {{ lang.title }}
        </h4>

        <form @submit.prevent="login" @keydown="form.errors.clear($event.target.name)">
            <my-input
                v-model="form.password"
                name="password"
                type="password"
                :label="lang.placeholders.password"
                :autofocus="true"
            />
            <div class="row">
                <div class="col">
                    <div class="password_recovery">
                        <a :href="lang.password_recovery_url" class="btn btn-text">
                            {{ lang.labels.password_recovery|capitalize }}
                        </a>
                    </div>
                </div>

                <div class="col" v-if="$root.country == 'it'">
                    <div class="privacy_link">
                        <a target="_blank" href="/privacy/login.html" class="btn btn-text">                    
                            {{ lang.labels.privacy|capitalize }}                  
                        </a>
                    </div>
                </div>
            </div>

            <error-span :error="form.errors.get('password')"></error-span>

            <button class="btn btn-network" :disabled="form.errors.any()">
                {{ lang.labels.login }}
            </button>
        </form>
    </div>
</template>

<script>
import { Form } from '../../classes/Form'

export default {
    components: {
    },

    props: {
    },

    data() {
        return {
            error: '',
            form: new Form({
                password: '',
            }),
            message: '',
            rules: {
                password: ['required'],
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },
    },

    methods: {
        login() {
            if(! this.form.validate(this.rules)) {
                return false
            }

            this.$emit('next', this.form.password)
        },
    },
}
</script>